/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteRouteImport } from './routes/_public/route'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PublicSupportIndexRouteImport } from './routes/_public/support/index'
import { Route as PublicResetPasswordIndexRouteImport } from './routes/_public/reset-password/index'
import { Route as PublicRegisterIndexRouteImport } from './routes/_public/register/index'
import { Route as PublicPrivacyPolicyIndexRouteImport } from './routes/_public/privacy-policy/index'
import { Route as PublicLoginIndexRouteImport } from './routes/_public/login/index'
import { Route as PublicForgotPasswordIndexRouteImport } from './routes/_public/forgot-password/index'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as AuthenticatedDashboardSettingsIndexRouteImport } from './routes/_authenticated/dashboard/settings/index'
import { Route as AuthenticatedDashboardDevicesIndexRouteImport } from './routes/_authenticated/dashboard/devices/index'
import { Route as AuthenticatedDashboardDevicesIdIndexRouteImport } from './routes/_authenticated/dashboard/devices/$id/index'

const PublicRouteRoute = PublicRouteRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicSupportIndexRoute = PublicSupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicResetPasswordIndexRoute =
  PublicResetPasswordIndexRouteImport.update({
    id: '/reset-password/',
    path: '/reset-password/',
    getParentRoute: () => PublicRouteRoute,
  } as any)
const PublicRegisterIndexRoute = PublicRegisterIndexRouteImport.update({
  id: '/register/',
  path: '/register/',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicPrivacyPolicyIndexRoute =
  PublicPrivacyPolicyIndexRouteImport.update({
    id: '/privacy-policy/',
    path: '/privacy-policy/',
    getParentRoute: () => PublicRouteRoute,
  } as any)
const PublicLoginIndexRoute = PublicLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicForgotPasswordIndexRoute =
  PublicForgotPasswordIndexRouteImport.update({
    id: '/forgot-password/',
    path: '/forgot-password/',
    getParentRoute: () => PublicRouteRoute,
  } as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardSettingsIndexRoute =
  AuthenticatedDashboardSettingsIndexRouteImport.update({
    id: '/dashboard/settings/',
    path: '/dashboard/settings/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardDevicesIndexRoute =
  AuthenticatedDashboardDevicesIndexRouteImport.update({
    id: '/dashboard/devices/',
    path: '/dashboard/devices/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardDevicesIdIndexRoute =
  AuthenticatedDashboardDevicesIdIndexRouteImport.update({
    id: '/dashboard/devices/$id/',
    path: '/dashboard/devices/$id/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/forgot-password/': typeof PublicForgotPasswordIndexRoute
  '/login/': typeof PublicLoginIndexRoute
  '/privacy-policy/': typeof PublicPrivacyPolicyIndexRoute
  '/register/': typeof PublicRegisterIndexRoute
  '/reset-password/': typeof PublicResetPasswordIndexRoute
  '/support/': typeof PublicSupportIndexRoute
  '/dashboard/devices/': typeof AuthenticatedDashboardDevicesIndexRoute
  '/dashboard/settings/': typeof AuthenticatedDashboardSettingsIndexRoute
  '/dashboard/devices/$id/': typeof AuthenticatedDashboardDevicesIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/forgot-password': typeof PublicForgotPasswordIndexRoute
  '/login': typeof PublicLoginIndexRoute
  '/privacy-policy': typeof PublicPrivacyPolicyIndexRoute
  '/register': typeof PublicRegisterIndexRoute
  '/reset-password': typeof PublicResetPasswordIndexRoute
  '/support': typeof PublicSupportIndexRoute
  '/dashboard/devices': typeof AuthenticatedDashboardDevicesIndexRoute
  '/dashboard/settings': typeof AuthenticatedDashboardSettingsIndexRoute
  '/dashboard/devices/$id': typeof AuthenticatedDashboardDevicesIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_public': typeof PublicRouteRouteWithChildren
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_public/forgot-password/': typeof PublicForgotPasswordIndexRoute
  '/_public/login/': typeof PublicLoginIndexRoute
  '/_public/privacy-policy/': typeof PublicPrivacyPolicyIndexRoute
  '/_public/register/': typeof PublicRegisterIndexRoute
  '/_public/reset-password/': typeof PublicResetPasswordIndexRoute
  '/_public/support/': typeof PublicSupportIndexRoute
  '/_authenticated/dashboard/devices/': typeof AuthenticatedDashboardDevicesIndexRoute
  '/_authenticated/dashboard/settings/': typeof AuthenticatedDashboardSettingsIndexRoute
  '/_authenticated/dashboard/devices/$id/': typeof AuthenticatedDashboardDevicesIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard/'
    | '/forgot-password/'
    | '/login/'
    | '/privacy-policy/'
    | '/register/'
    | '/reset-password/'
    | '/support/'
    | '/dashboard/devices/'
    | '/dashboard/settings/'
    | '/dashboard/devices/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/privacy-policy'
    | '/register'
    | '/reset-password'
    | '/support'
    | '/dashboard/devices'
    | '/dashboard/settings'
    | '/dashboard/devices/$id'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_public'
    | '/_authenticated/dashboard/'
    | '/_public/forgot-password/'
    | '/_public/login/'
    | '/_public/privacy-policy/'
    | '/_public/register/'
    | '/_public/reset-password/'
    | '/_public/support/'
    | '/_authenticated/dashboard/devices/'
    | '/_authenticated/dashboard/settings/'
    | '/_authenticated/dashboard/devices/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/support/': {
      id: '/_public/support/'
      path: '/support'
      fullPath: '/support/'
      preLoaderRoute: typeof PublicSupportIndexRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/reset-password/': {
      id: '/_public/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password/'
      preLoaderRoute: typeof PublicResetPasswordIndexRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/register/': {
      id: '/_public/register/'
      path: '/register'
      fullPath: '/register/'
      preLoaderRoute: typeof PublicRegisterIndexRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/privacy-policy/': {
      id: '/_public/privacy-policy/'
      path: '/privacy-policy'
      fullPath: '/privacy-policy/'
      preLoaderRoute: typeof PublicPrivacyPolicyIndexRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/login/': {
      id: '/_public/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof PublicLoginIndexRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/forgot-password/': {
      id: '/_public/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password/'
      preLoaderRoute: typeof PublicForgotPasswordIndexRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/settings/': {
      id: '/_authenticated/dashboard/settings/'
      path: '/dashboard/settings'
      fullPath: '/dashboard/settings/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/devices/': {
      id: '/_authenticated/dashboard/devices/'
      path: '/dashboard/devices'
      fullPath: '/dashboard/devices/'
      preLoaderRoute: typeof AuthenticatedDashboardDevicesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/devices/$id/': {
      id: '/_authenticated/dashboard/devices/$id/'
      path: '/dashboard/devices/$id'
      fullPath: '/dashboard/devices/$id/'
      preLoaderRoute: typeof AuthenticatedDashboardDevicesIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedRouteRouteChildren {
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
  AuthenticatedDashboardDevicesIndexRoute: typeof AuthenticatedDashboardDevicesIndexRoute
  AuthenticatedDashboardSettingsIndexRoute: typeof AuthenticatedDashboardSettingsIndexRoute
  AuthenticatedDashboardDevicesIdIndexRoute: typeof AuthenticatedDashboardDevicesIdIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
  AuthenticatedDashboardDevicesIndexRoute:
    AuthenticatedDashboardDevicesIndexRoute,
  AuthenticatedDashboardSettingsIndexRoute:
    AuthenticatedDashboardSettingsIndexRoute,
  AuthenticatedDashboardDevicesIdIndexRoute:
    AuthenticatedDashboardDevicesIdIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface PublicRouteRouteChildren {
  PublicForgotPasswordIndexRoute: typeof PublicForgotPasswordIndexRoute
  PublicLoginIndexRoute: typeof PublicLoginIndexRoute
  PublicPrivacyPolicyIndexRoute: typeof PublicPrivacyPolicyIndexRoute
  PublicRegisterIndexRoute: typeof PublicRegisterIndexRoute
  PublicResetPasswordIndexRoute: typeof PublicResetPasswordIndexRoute
  PublicSupportIndexRoute: typeof PublicSupportIndexRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicForgotPasswordIndexRoute: PublicForgotPasswordIndexRoute,
  PublicLoginIndexRoute: PublicLoginIndexRoute,
  PublicPrivacyPolicyIndexRoute: PublicPrivacyPolicyIndexRoute,
  PublicRegisterIndexRoute: PublicRegisterIndexRoute,
  PublicResetPasswordIndexRoute: PublicResetPasswordIndexRoute,
  PublicSupportIndexRoute: PublicSupportIndexRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  PublicRouteRoute: PublicRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
